import { SkeletonLoader } from '@civilgrid/ui/SkeletonLoader';
import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import type { RegionWithId } from '~/common/types';

import rootStore from '~/store';

export const Regions = () => {
  const { currentOrganization } = useSnapshot(rootStore) as typeof rootStore;
  const [isLoading, setIsLoading] = useState(true);
  const [regions, setRegions] = useState<RegionWithId[]>([]);

  useEffect(() => {
    if (!currentOrganization) return;
    setRegions(currentOrganization.regions);
    setIsLoading(false);
  }, [currentOrganization]);

  if (isLoading) {
    return (
      <div className="col-span-2">
        <div className="text-sm font-bold">Regions</div>
        <SkeletonLoader height={80} width={336} />
      </div>
    );
  }
  const regionNames = regions.map((r) => r.name);

  return (
    <div className="col-span-2 flex flex-col gap-1">
      <div className="text-sm font-bold">Regions</div>
      <div className="text-sm">You currently have access to the following regions:</div>
      {regionNames.map((region) => {
        return (
          <div key={region} className="pl-2 text-sm">
            - {region}
          </div>
        );
      })}
      <div className="text-sm">
        Click{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:support@civilgrid.com?subject=Request Additional Regions`}
          className="text-blue-50 underline hover:text-blue-60"
        >
          here
        </a>{' '}
        to request additional regions.
      </div>
    </div>
  );
};
